import { render, staticRenderFns } from "./ElasticChatStartups.vue?vue&type=template&id=fe157fd8&scoped=true&"
import script from "./ElasticChatStartups.vue?vue&type=script&setup=true&lang=js&"
export * from "./ElasticChatStartups.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe157fd8",
  null
  
)

export default component.exports